import { CharacterIcon } from '~/app/(default-layout)/s/[storyId]/_components/chat-script-render/op/character-icon';
import type { CharacterWithPosition } from '~/app/_types/chat-script';
import { cva } from '@styled-system/css';
import { Box, BoxProps, Flex, Paragraph } from '@styled-system/jsx';

type Props = {
  character: CharacterWithPosition;
  withTip?: boolean;
  baseTextColor?: string;
} & BoxProps;

export const Balloon: React.FC<Props> = ({
  character,
  withTip,
  children,
  ...boxProps
}) => (
  <Box
    position="relative"
    wordBreak="break-all"
    fontSize="size_18"
    fontWeight={400}
    {...boxProps}
  >
    <Flex
      mr={character.position === 'right' ? '47px' : '0'}
      ml={character.position === 'left' ? '47px' : '0'}
      flexDir="column"
      alignItems={character.position === 'right' ? 'flex-end' : 'flex-start'}
    >
      <Paragraph
        fontSize="size_13"
        fontWeight="bold"
        mb="8px"
        color="primary"
        textShadow="0 0 4px rgba(0, 0, 0, 0.2)"
      >
        {character.name || '指定されてない'}
      </Paragraph>
      {withTip ? (
        <>
          <div
            className={balloon({
              visual:
                character.position === 'right' ? 'chat_right' : 'chat_left',
            })}
          >
            {children}
          </div>
        </>
      ) : (
        <>
          <div
            className={balloon({
              visual:
                character.position === 'right' ? 'talk_right' : 'talk_left',
            })}
          >
            {children}
          </div>
        </>
      )}
      <CharacterIcon
        src={character.thumbnailUrl}
        position="absolute"
        top="0"
        right={character.position === 'right' ? '0' : undefined}
        left={character.position === 'left' ? '0' : undefined}
      />
    </Flex>
  </Box>
);

const balloon = cva({
  base: {
    position: 'relative',
    zIndex: 0,
    lineHeight: 1.4,
    minHeight: '30px',
    minWidth: '40px',
    whiteSpace: 'break-spaces',
  },
  variants: {
    visual: {
      chat_left: {
        background: 'chat_balloon_bg',
        borderRadius: '22px',
        padding: '10px 16px',
        fontSize: 'size_16',

        _before: {
          content: '" "',
          position: 'absolute',
          top: '2px',
          left: '-1px',
          width: '12px',
          height: '12px',
          display: 'block',
          background: `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAQAAABwdJQDAAAAlElEQVR4AZXLGQDDQBhE4TitU5ziFKc4xSlOdVqnONXpd6rTOgWn53R638e8x1/FhIxgX/0b+hU1Uf5EGI7giph+gXrF+zFhZPeVoaz4OgKZHZp3YLbit1EQejw+F2Ba8f+rQwgXtB5QCBe0HlAIF9QeUMgmYEJxgELrAYVsAiYUB6ipweQAhcEDCtkDCosVV7t37wH8T7qXUXTKgQAAAABJRU5ErkJggg==") center/cover;`,
        },
      },
      chat_right: {
        background: 'main_balloon_bg',
        borderRadius: '22px',
        padding: '10px 16px',
        fontSize: 'size_16',

        _before: {
          position: 'absolute',
          top: '2px',
          right: '-1px',
          width: '12px',
          height: '12px',
          content: '" "',
          display: 'block',
          background: `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAAA1UlEQVR4AbWU0Q2CYAyEbwRHcALoCIzgBo4gG8ibCWBkA0bQDRiBEQoTOAK2iU3EoCj8/ZJ7+F/uzrMBoSn76Fh2cVN0cX1h2iAUBVMipizmg6ngKMUatKE0PohZa6Yj9bRfZPpsW4vJfcrYlDMR5jgxbUumXc5RpdvOmZp0LijyuGobk75F7dn2XCjZP7OAwUP6y90CpP0Nhk8AJZ4BDV7xa+8QoFeIdxwuZ0zAaTJMEWgazj59OQP/sQ4BTBW+4TaNsfpq5lixe4pfcNh9zILdW/zBAyYroGGvzCsTAAAAAElFTkSuQmCC") center/cover`,
        },
      },
      talk_left: {
        p: '10px 16px 10px 0',

        _before: {
          content: '" "',
          display: 'block',
          position: 'absolute',
          top: '0',
          bottom: '0',
          right: '0',
          left: '-20px',
          zIndex: -1,
          background: 'balloon_bg',
          borderRadius: '10px',
        },
      },
      talk_right: {
        p: '10px 0 10px 16px',

        _before: {
          content: '" "',
          display: 'block',
          position: 'absolute',
          top: '0',
          bottom: '0',
          left: '0',
          right: '-20px',
          zIndex: -1,
          background: 'balloon_bg',
          borderRadius: '10px',
        },
      },
    },
  },
});
